import React, { useState } from 'react';

import BaseModal, { modalSizes } from 'flow/components/ui-components/BaseModal';
import DropdownMenuComponent from 'flow/components/ui-components/DropdownMenuComponent';
import Icon from 'flow/components/ui-components/Icon';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { ChatSessionKey } from 'flow/types/EntityKeys';
import { getSummaryOptions } from 'flow/utils/chat-utils';

export interface Props {
    chatSessionKey?: ChatSessionKey;
}

const GenerateChatSummaryModal = ({ chatSessionKey }: Props) => {
    const { i18next } = useAppContext();
    const { openModal } = useModal();

    const options = getSummaryOptions(i18next);

    const [selectedOption, setSelectedOption] = useState(options[0]);

    return (
        <BaseModal
            open={true}
            header={i18next.t('chat.generateSummary.title')}
            modalSize={modalSizes.SMALL}
            onContinue={() =>
                openModal('chatSummary', {
                    chatSessionKey,
                    summaryOption: selectedOption.key,
                })
            }
            confirmButtonText={
                <div className="flex items-center gap-2">
                    <Icon
                        iconKey="autoFixWand"
                        style={{ width: '20px', height: '20px' }}
                    />
                    {i18next.t('chat.generateSummary.summarize')}
                </div>
            }
        >
            <div className="flex flex-col gap-4">
                <p className="text-sm/6">
                    {i18next.t('chat.generateSummary.description')}
                </p>

                <div>
                    <DropdownMenuComponent
                        title={selectedOption.label}
                        label={i18next.t('chat.generateSummary.selectRange')}
                        onItemSelected={(key) =>
                            setSelectedOption(
                                options.find((opt) => opt.key === key),
                            )
                        }
                        options={options}
                    />
                </div>
            </div>
        </BaseModal>
    );
};

export default GenerateChatSummaryModal;
